import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/toys-bg.png";
import verifyy from "../assets/verification.png";
import { useForgetPassword } from "../../context/ForgetPasswordContext";

const Verification = () => {
  const { verifyOtp } = useForgetPassword();
  const [code, setCode] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      // Auto-focus next input
      if (value && index < code.length - 1) {
        const nextInput = document.getElementById(`code-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  const handleVerify = async () => {
    const otp = code.join("");
    if (otp.length !== 4) {
      setError("Please enter the 4-digit code.");
      return;
    }

    setLoading(true);
    setError(null);

    const response = await verifyOtp(otp);
    setLoading(false);

    if (response.status === 200) {
      navigate("/reset"); // proceed to reset password
    } else {
      setError(response.message || "Invalid code. Please try again.");
    }
  };

  const handleResend = () => {
    alert("Verification code resent"); // You can integrate API resend here
  };

  return (
    <section
      className="min-h-screen flex justify-center md:justify-end items-center bg-cover bg-center px-4"
      style={{ backgroundImage: `url("https://cdn.acsdev.in/Rentastic/toysb.png")` }}
    >
      <div className="w-full max-w-md sm:max-w-sm md:max-w-md lg:max-w-lg bg-white/90 backdrop-blur-sm rounded-2xl shadow-md p-6 sm:p-8 md:p-10 mx-4 md:mr-16 lg:mr-32">
        {/* Logo & Heading */}
        <div className="flex flex-col items-center">
          <div className="w-24 h-24 rounded-full flex items-center justify-center mb-3">
            <img src="https://cdn.acsdev.in/Rentastic/verification.png" alt="logo" className="w-30 h-30 object-contain" />
          </div>
          <h1 className="text-lg font-bold text-gray-800">Rentastic Toys</h1>
          <p className="text-md font-semibold text-gray-900 mt-2">Verification Code</p>
          <p className="text-sm text-gray-500 mt-1 text-center px-4">
            Please enter the 4-digit code we sent to your email.
          </p>
        </div>

        {/* Code Inputs */}
        <div className="flex justify-center space-x-4 mt-6">
          {code.map((digit, index) => (
            <input
              key={index}
              id={`code-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              className="w-12 h-12 text-center border-2 rounded-lg text-lg font-semibold focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none"
            />
          ))}
        </div>

        {error && <p className="text-red-500 text-sm text-center mt-2">{error}</p>}

        {/* Verify Button */}
        <button
          type="button"
          onClick={handleVerify}
          disabled={loading}
          className={`w-full mt-6 bg-green-500 text-white font-semibold py-2 rounded-full shadow transition-colors duration-300 ${
            loading ? "opacity-70 cursor-not-allowed" : "hover:bg-green-600"
          }`}
        >
          {loading ? "Verifying..." : "Verify"}
        </button>

        {/* Resend Code */}
        <div className="text-center mt-6 text-sm text-gray-600">
          Didn’t receive the code?{" "}
          <button
            onClick={handleResend}
            className="text-orange-500 font-semibold hover:underline"
          >
            Resend
          </button>
        </div>

        {/* Back to Login */}
        <div className="text-center mt-2 text-sm text-gray-600">
          <button
            onClick={() => navigate("/login")}
            className="text-orange-500 font-semibold hover:underline"
          >
            Back to Login
          </button>
        </div>
      </div>
    </section>
  );
};

export default Verification;
